import React from 'react';
import { TRUST_TIERS } from '../../services/FraudPreventionService';

const TIER_STYLES = {
  0: {
    bg: 'bg-gray-100 dark:bg-white/5',
    text: 'text-gray-600 dark:text-[#999999]',
    dot: 'bg-gray-400 dark:bg-gray-500',
  },
  1: {
    bg: 'bg-blue-50 dark:bg-blue-500/10',
    text: 'text-blue-600 dark:text-blue-400',
    dot: 'bg-blue-500',
  },
  2: {
    bg: 'bg-emerald-50 dark:bg-emerald-500/10',
    text: 'text-emerald-600 dark:text-emerald-400',
    dot: 'bg-emerald-500',
  },
};

export default function TrustTierBadge({ tier = 0, showDetails = false }) {
  const tierConfig = Object.values(TRUST_TIERS).find(t => t.id === tier) || TRUST_TIERS.TIER_0;
  const styles = TIER_STYLES[tier] || TIER_STYLES[0];

  return (
    <div className="inline-flex flex-col">
      <span
        className={`inline-flex items-center gap-1.5 px-2 py-0.5 text-[11px] rounded-full font-medium ${styles.bg} ${styles.text}`}
      >
        <span className={`w-1.5 h-1.5 rounded-full ${styles.dot}`} />
        Tier {tier}
      </span>
      {showDetails && (
        <div className="mt-1.5 space-y-0.5 pl-0.5">
          <p className="text-[10px] text-gray-400 dark:text-[#666666]">
            {tierConfig.payoutDelayDays}d delay · {tierConfig.name}
          </p>
          {tierConfig.reservePercent > 0 && (
            <p className="text-[10px] text-gray-400 dark:text-[#666666]">
              {tierConfig.reservePercent}% reserve · {tierConfig.reserveDurationDays}d hold
            </p>
          )}
        </div>
      )}
    </div>
  );
}
